import React, { useMemo, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import Select from "react-select";
import MapboxAutocomplete from "react-mapbox-autocomplete";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";






  
const schema = yup.object().shape({
  fullName: yup.string().required("Full name is required"),
  phone: yup
    .string()
    .matches(/^05\d{8}$/, "Phone number must be in the correct format")
    .required("Phone number is required"),
  city: yup.object().shape({ value: yup.string().required("City selection is required") }),
  address: yup.string().required("Address is required"),
});

const MapManual = () => {
    const { t, i18n } = useTranslation();
    const cities = useMemo(() => [
      { value: "riyadh", label: t("Riyadh") },
      { value: "jeddah", label: t("Jeddah") },
      { value: "dammam", label: t("Dammam") },
      { value: "makkah", label: t("Makkah") },
      { value: "medina", label: t("Medina") },
      { value: "khobar", label: t("Khobar") },
      { value: "tabuk", label: t("Tabuk") },
      { value: "buraydah", label: t("Buraydah") },
      { value: "khamis", label: t("Khamis Mushait") },
      { value: "jazan", label: t("Jazan") },
      { value: "najran", label: t("Najran") },
      { value: "hail", label: t("Hail") },
      { value: "abha", label: t("Abha") },
      { value: "jubail", label: t("Jubail") },
      { value: "alhufuf", label: t("Al-Hufuf") },
      { value: "alqatif", label: t("Al Qatif") },
      { value: "arar", label: t("Arar") },
      { value: "sakaka", label: t("Sakaka") },
      { value: "albahah", label: t("Al Bahah") },
      { value: "rabigh", label: t("Rabigh") },
      { value: "qurayyat", label: t("Qurayyat") },
      { value: "yanbu", label: t("Yanbu") },
      { value: "dhahran", label: t("Dhahran") },
      { value: "taif", label: t("Taif") }
    ], [t]);
    
    const [submit_content, set_submit_content] = useState(t("Confirm Location"));

    const navigate = useNavigate()
    
  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });
  
  const onSubmit = (data) => {
    set_submit_content(<div className="inputLoader"></div>);
    // Log the user’s address in Arabic

    localStorage.setItem("address_details", data.address);
    localStorage.setItem("address_city", data.city.label);
    setTimeout(() => {
      navigate("/details");
    }, 2000);

    
  };

  return (
    <>
    <div className="max-w-md p-6 mx-auto text-left bg-white rounded">
        <div className="flex items-center justify-center w-full py-2 mb-4 border-b">
        <svg className="absolute left-6" onClick={()=>navigate('/')} stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 16 16" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" d="M5.854 4.646a.5.5 0 010 .708L3.207 8l2.647 2.646a.5.5 0 01-.708.708l-3-3a.5.5 0 010-.708l3-3a.5.5 0 01.708 0z" clipRule="evenodd"></path>
          <path fillRule="evenodd" d="M2.5 8a.5.5 0 01.5-.5h10.5a.5.5 0 010 1H3a.5.5 0 01-.5-.5z" clipRule="evenodd"></path>
        </svg>
      <h2 className="text-xl font-semibold">{t("Select a Delivery Location")}</h2>
        </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mb-4">
          <label className="block text-sm font-medium">{t("Full Name")}</label>
          <input {...register("fullName")} className="w-full p-2 border rounded" placeholder={t("Type your name here")} />
          {errors.fullName && <p className="text-sm text-red-500">{errors.fullName.message}</p>}
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium">{t("Mobile Number")}</label>
          <input {...register("phone")} type="tel" className="w-full p-2 border rounded" placeholder={t("05XXXXXXXX")} />
          {errors.phone && <p className="text-sm text-red-500">{errors.phone.message}</p>}
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium">{t("City")}</label>
          <Controller
            name="city"
            control={control}
            render={({ field }) => <Select {...field} options={cities} placeholder={t("Select a city")} className="w-full" />}
          />
          {errors.city && <p className="text-sm text-red-500">{errors.city.value?.message}</p>}
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium">{t("Address")}</label>
          <input {...register("address")} type="text" className="w-full p-2 border rounded" placeholder={t("Enter your address")} />
          {errors.address && <p className="text-sm text-red-500">{errors.address.message}</p>}
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium">{t("Apartment/Unit")}</label>
          <input  className="w-full p-2 border rounded" placeholder={t("Enter your apartment/unit number")} />
        </div>
        
      <div className="fixed bottom-0 left-0 right-0 w-full p-6 pb-12 bg-white">
        <button type="submit" className="w-full py-3 text-black font-semibold bg-[#FFD600] rounded">{submit_content}</button>
      </div>
      </form>
    </div>

    </>

  );
};

export default MapManual;